// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__zPtP1","btn_dark":"Button_btn_dark__onsXr","cta":"Button_cta__pcckA","cta_dark":"Button_cta_dark__Wbgae","universal":"Button_universal__ySkS9"};